import script from "./SwitchDma.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchDma.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__